import { PATHNAME, COMPONENT_NAME } from "../util/constants";

export default [{
    _name: "CSidebarNav",

    _children: [{
            _name: "CSidebarNavItem",
            name: "Dashboard",
            to: "/dashboard",
            icon: "cil-speedometer",
            badge: {
                color: "primary",
                text: "NEW"
            }
        },
        {
            _name: "CSidebarNavTitle",
            _children: ["Theme"]
        },
        {
            _name: "CSidebarNavItem",
            name: "Colors",
            to: "/theme/colors",
            icon: "cil-drop"
        },
        {
            _name: "CSidebarNavItem",
            name: "Typography",
            to: "/theme/typography",
            icon: "cil-pencil"
        },
        {
            _name: "CSidebarNavTitle",
            _children: ["Components"]
        },
        {
            _name: "CSidebarNavDropdown",
            name: "Base",
            route: "/base",
            icon: "cil-puzzle",
            items: [{
                    name: "Breadcrumbs",
                    to: "/base/breadcrumbs",
                    icon: "cil-puzzle"
                },
                {
                    name: "Cards",
                    to: "/base/cards",
                    icon: "cil-puzzle"
                },
                {
                    name: "Carousels",
                    to: "/base/carousels",
                    icon: "cil-puzzle"
                },
                {
                    name: "Collapses",
                    to: "/base/collapses",
                    icon: "cil-puzzle"
                },
                {
                    name: "Forms",
                    to: "/base/forms",
                    icon: "cil-puzzle"
                },
                {
                    name: "Jumbotrons",
                    to: "/base/jumbotrons",
                    icon: "cil-puzzle"
                },
                {
                    name: "List Groups",
                    to: "/base/list-groups",
                    icon: "cil-puzzle"
                },
                {
                    name: "Navs",
                    to: "/base/navs",
                    icon: "cil-puzzle"
                },
                {
                    name: "Navbars",
                    to: "/base/navbars",
                    icon: "cil-puzzle"
                },
                {
                    name: "Paginations",
                    to: "/base/paginations",
                    icon: "cil-puzzle"
                },
                {
                    name: "Popovers",
                    to: "/base/popovers",
                    icon: "cil-puzzle"
                },
                {
                    name: "Progress Bars",
                    to: "/base/progress-bars",
                    icon: "cil-puzzle"
                },
                {
                    name: "Switches",
                    to: "/base/switches",
                    icon: "cil-puzzle"
                },
                {
                    name: "Tables",
                    to: "/base/tables",
                    icon: "cil-puzzle"
                },
                {
                    name: "Tabs",
                    to: "/base/tabs",
                    icon: "cil-puzzle"
                },
                {
                    name: "Tooltips",
                    to: "/base/tooltips",
                    icon: "cil-puzzle"
                }
            ]
        },
        {
            _name: "CSidebarNavDropdown",
            name: "Buttons",
            route: "/buttons",
            icon: "cil-cursor",
            items: [{
                    name: "Buttons",
                    to: "/buttons/standard-buttons",
                    icon: "cil-cursor"
                },
                {
                    name: "Button Dropdowns",
                    to: "/buttons/dropdowns",
                    icon: "cil-cursor"
                },
                {
                    name: "Button Groups",
                    to: "/buttons/button-groups",
                    icon: "cil-cursor"
                },
                {
                    name: "Brand Buttons",
                    to: "/buttons/brand-buttons",
                    icon: "cil-cursor"
                }
            ]
        },
        {
            _name: "CSidebarNavItem",
            name: "Charts",
            to: "/charts",
            icon: "cil-chart-pie"
        },
        {
            _name: "CSidebarNavDropdown",
            name: "Icons",
            route: "/icons",
            icon: "cil-star",
            items: [{
                    name: "CoreUI Icons",
                    to: "/icons/coreui-icons",
                    icon: "cil-star",
                    badge: {
                        color: "info",
                        text: "NEW"
                    }
                },
                {
                    name: "Brands",
                    to: "/icons/brands",
                    icon: "cil-star"
                },
                {
                    name: "Flags",
                    to: "/icons/flags",
                    icon: "cil-star"
                }
            ]
        },
        {
            _name: "CSidebarNavDropdown",
            name: "Notifications",
            route: "/notifications",
            icon: "cil-bell",
            items: [{
                    name: "Alerts",
                    to: "/notifications/alerts",
                    icon: "cil-bell"
                },
                {
                    name: "Badges",
                    to: "/notifications/badges",
                    icon: "cil-bell"
                },
                {
                    name: "Modals",
                    to: "/notifications/modals",
                    icon: "cil-bell"
                }
            ]
        },
        {
            _name: "CSidebarNavItem",
            name: "Widgets",
            to: "/widgets",
            icon: "cil-calculator",
            badge: {
                color: "primary",
                text: "NEW",
                shape: "pill"
            }
        },
        {
            _name: "CSidebarNavDivider",
            _class: "m-2"
        },
        {
            _name: "CSidebarNavTitle",
            _children: ["Extras"]
        },
        {
            _name: "CSidebarNavDropdown",
            name: COMPONENT_NAME.PAGES,
            route: PATHNAME.PAGES,
            icon: "cil-star",
            items: [
                // {
                //     name: 'Login',
                //     to: '/pages/login',
                //     icon: 'cil-star'
                // },
                // {
                //     name: 'Register',
                //     to: '/pages/register',
                //     icon: 'cil-star'
                // },
                {
                    name: COMPONENT_NAME.PAGE_404,
                    to: PATHNAME.PAGE_404,
                    icon: "cil-star"
                },
                {
                    name: COMPONENT_NAME.PAGE_500,
                    to: PATHNAME.PAGE_500,
                    icon: "cil-star"
                }
            ]
        },
        {
            icon: "cil-airplane-mode",
            _name: "CSidebarNavDropdown",
            name: COMPONENT_NAME.SEARCHPAGE,
            route: PATHNAME.BOOKING,

            items: [{
                    icon: "cil-airplane-mode",
                    name: "FlightSearch",
                    to: "/booking/flight/search"
                }
                // {
                //     icon: 'cil-flight-takeoff',
                //     name: "FlightResults",
                //     to: '/booking/flight/result',
                // },
            ]
        },
        // {
        //     _name: 'CSidebarNavItem',
        //     name: COMPONENT_NAME.PAYMENTPAGE,
        //     to: PATHNAME.PAYMENTPAGE,
        //     // icon: 'cil-chart-pie'
        // },
        {
            icon: "cil-money",
            _name: "CSidebarNavDropdown",
            name: COMPONENT_NAME.PRICING,
            route: PATHNAME.PRICING,
            items: [{
                    name: "Setup",
                    to: PATHNAME.SETUP_PRICING,
                    icon: "cil-money"
                },
                // {
                //     name: COMPONENT_NAME.CHANGE_PRICING,
                //     to: PATHNAME.CHANGE_PRICING,
                //     icon: 'cil-money',
                // },

                {
                    name: COMPONENT_NAME.ASSIGN_PRICING,
                    to: PATHNAME.ASSIGN_PRICING,
                    icon: "cil-money"
                }
            ]
        },

        {
            icon: "cil-settings",
            _name: "CSidebarNavDropdown",
            name: COMPONENT_NAME.TOOLS,
            route: PATHNAME.TOOLS,
            items: [{
                    icon: "cil-thumb-up",
                    name: COMPONENT_NAME.ROUTES,
                    to: PATHNAME.ROUTES,
                },
                {
                    icon: 'cil-thumb-up',
                    name: COMPONENT_NAME.CLASSES,
                    to: PATHNAME.CLASSES,
                },
                {
                    icon: 'cil-thumb-up',
                    name: COMPONENT_NAME.CURRENCY,
                    to: PATHNAME.CURRENCY,
                },
                {
                    icon: 'cil-thumb-up',
                    name: COMPONENT_NAME.STATE_PROVINCE,
                    to: PATHNAME.STATE_PROVINCE,
                },
                // {
                //     icon: 'cil-thumb-up',
                //     name: COMPONENT_NAME.EXTENSION_SETUP,
                //     to: PATHNAME.EXTENSION_SETUP,
                // }
            ]
        },

        {
            icon: "cil-user",
            _name: "CSidebarNavDropdown",
            name: COMPONENT_NAME.USERS,
            route: PATHNAME.USERS,
            items: [{
                    icon: "cil-people",
                    name: COMPONENT_NAME.MANAGE_USERS,
                    to: PATHNAME.MANAGE_USERS
                },
                {
                    icon: "cil-functions",
                    name: COMPONENT_NAME.ROLES_PERMISSIONS,
                    to: PATHNAME.ROLES_PERMISSIONS
                },
                {
                    icon: "cil-fingerprint",
                    name: COMPONENT_NAME.CHANGE_PASSWORD,
                    to: PATHNAME.CHANGE_PASSWORD
                }
            ]
        },
        {
            icon: "cil-pen-alt",
            _name: "CSidebarNavDropdown",
            name: COMPONENT_NAME.AGENT_REG,
            route: PATHNAME.AGENT_REG,
            items: [{
                    icon: "cil-thumb-up",
                    name: COMPONENT_NAME.APPROVE_AGENT,
                    to: PATHNAME.APPROVE_AGENT
                },
                {
                    icon: "cil-thumb-up",
                    name: COMPONENT_NAME.MANAGE_AGENT,
                    to: PATHNAME.MANAGE_AGENT
                },
            ]
        },

        {
            icon: "cil-pen-alt",
            _name: "CSidebarNavDropdown",
            name: COMPONENT_NAME.POSTPAID,
            route: PATHNAME.POSTPAID,
            items: [{
                    icon: "cil-thumb-up",
                    name: COMPONENT_NAME.DEPOSIT,
                    to: PATHNAME.DEPOSIT
                },
                {
                    icon: "cil-thumb-up",
                    name: COMPONENT_NAME.PENDING_INVOICES,
                    to: PATHNAME.PENDING_INVOICES
                },
                {
                    icon: "cil-thumb-up",
                    name: COMPONENT_NAME.VIEW_STATEMENTS,
                    to: PATHNAME.VIEW_STATEMENTS
                }
            ]
        },

        {
            icon: "cil-user-follow",
            _name: "CSidebarNavItem",
            name: COMPONENT_NAME.AGENT_LOGIN,
            to: PATHNAME.AGENT_LOGIN
        },
        {
            icon: 'cil-pen-alt',
            _name: 'CSidebarNavDropdown',
            name: COMPONENT_NAME.CREDIT_NOTE,
            route: PATHNAME.CREDIT_NOTE,
            items: [{
                    icon: 'cil-thumb-up',
                    name: COMPONENT_NAME.CREDIT,
                    to: PATHNAME.CREDIT,
                },
                {
                    icon: 'cil-thumb-up',
                    name: COMPONENT_NAME.CREDIT_REPORT,
                    to: PATHNAME.CREDIT_REPORT,
                },

            ]
        },
        {
            _name: "CSidebarNavItem",
            name: COMPONENT_NAME.DEBIT_NOTE,
            to: PATHNAME.DEBIT_NOTE,
            icon: "cil-money"
        },
        {
            _name: "CSidebarNavItem",
            name: COMPONENT_NAME.EXCHANGE_RATE,
            to: PATHNAME.EXCHANGE_RATE,
            icon: "cil-transfer"
        },
        /* {
            icon: 'cil-pen-alt',
            _name: 'CSidebarNavDropdown',
            name: COMPONENT_NAME.TOOLS,
            route: PATHNAME.TOOLS,
            items: [{
                    icon: 'cil-thumb-up',
                    name: COMPONENT_NAME.CLASSES,
                    to: PATHNAME.CLASSES,
                },

            ]
        }, */
        {

            icon: 'cil-description',
            _name: 'CSidebarNavItem',
            name: COMPONENT_NAME.REPORT,
            to: PATHNAME.REPORT
        },

        {
            icon: "cil-chart-line",
            _name: "CSidebarNavItem",
            name: COMPONENT_NAME.TOPUP,
            to: PATHNAME.TOPUP
        },
        // {
        //     _name: 'CSidebarNavItem',
        //     name: COMPONENT_NAME.PAXPAGE,
        //     to: COMPONENT_NAME.PAXPAGE,
        //     icon: 'cil-fax'
        // },
        {
            _name: "CSidebarNavItem",
            name: COMPONENT_NAME.SYSTEM_TOPUP,
            to: PATHNAME.SYSTEM_TOPUP,
            icon: "cil-airplay"
        },
        {
            _name: "CSidebarNavItem",
            name: COMPONENT_NAME.ROUTE,
            to: PATHNAME.ROUTE,
            icon: "cil-audio"
        }
    ]
}];